import { useTranslation } from 'react-i18next';
import { ICON } from './icon';
import { Button } from 'antd';
import UserService from '../../services/UserService';

export default function AccountNotFound() {
    const { t } = useTranslation('landing');
    return (
        <div className="flex flex-col items-center justify-center h-full relative p-4">
            <div className="text-center">{ICON.center}</div>
            <h1 className="text-3xl font-semibold text-center mt-4">
                {t('User account not found')}
            </h1>
            <div className="text-lg">
                <p className="text-center">
                    {t(
                        'Please contact your administrator to create a user account on WhiteFact'
                    )}
                </p>
                <div className="font-semibold">{t('Procedure')}</div>
                <div>
                    1.{' '}
                    {t(
                        'Provide your Microsoft email to the admin to create a user on the WhiteFact'
                    )}
                </div>
                <div>
                    2.{' '}
                    {t(
                        'Wait for the email to set the password and set the password successfully'
                    )}
                </div>
                <div>
                    3.{' '}
                    {t(
                        'After setting the password successfully, you can log in with Azure AD'
                    )}
                </div>
            </div>
            <Button
                className="w-[150px] text-tiny mt-10"
                onClick={() => UserService.doLogout()}
                type="primary"
                size="large"
            >
                {t('Back to login')}
            </Button>
            <div className="absolute right-0 top-0 opacity-30">
                {ICON.right}
            </div>
            <div className="absolute left-0 -bottom-2 opacity-30">
                {ICON.left}
            </div>
        </div>
    );
}
